import { Trans } from 'react-i18next';
import { z } from 'zod';

import Checkbox, { type CheckboxProps } from '@/core/components/Checkbox.tsx';
import Form from '@/core/components/Form.tsx';
import TextLink from '@/core/components/TextLink.tsx';

// Creating a workspace needs its owner to accept the terms and the AVV (plan task 57).
export const termsFormSchema = z.object({
    has_accepted_terms: z.boolean().refine((value) => value, 'errors.api.terms_not_accepted'),
});
export type TermsFormValues = z.input<typeof termsFormSchema>;

export const termsFormDefaults: TermsFormValues = { has_accepted_terms: false };

interface AcceptTermsCheckboxProps extends CheckboxProps {
    errorMessage?: string;
}

const AcceptTermsCheckbox = ({ errorMessage, ...props }: AcceptTermsCheckboxProps) => (
    <div className="flex flex-col gap-1.5">
        <Checkbox {...props} size="sm" className="items-start text-text-muted">
            {/* In a new tab, so what's entered in the form stays. */}
            <Trans
                i18nKey="legal.acceptTerms"
                components={{
                    terms: <TextLink href="/terms" target="_blank" isEmphasized />,
                    dpa: <TextLink href="/dpa" target="_blank" isEmphasized />,
                }}
            />
        </Checkbox>
        {errorMessage && <p className="text-sm text-negative">{errorMessage}</p>}
    </div>
);

const TermsFormFields = () => (
    <Form.Field name="has_accepted_terms">
        <AcceptTermsCheckbox />
    </Form.Field>
);

export default TermsFormFields;
